module.exports = __webpack_public_path__ + "img/408b23b.png";